module.exports = __webpack_public_path__ + "img/03.96db7e73.png";